<template>
	<div class="box">
		<div class="jd">
			<div class="jdbgbox">
				<div @click="tabCon(0)" class="zjd">总计划进度</div>
				<div @click="tabCon(1)" class="yjd">月计划进度</div>
			</div >
			<div v-show="index==0" class="monthlySchedule" id="monthlySchedule"></div>
			<div v-show="index==1" id="zSchedule"></div>
		</div>

	</div>
	
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data() {
			return {
				index: 0
			}
		},
		created() {
						
		},
		mounted() {
			this.monthly()
			this.zjindu()
		},
		methods: {
			tabCon(num) {

				this.index = num
			},
			monthly() {
				const colors = ['#89F7FE', '#6B74E9']
				let myChart = echarts.init(document.getElementById('monthlySchedule'));
				let option = {
					color: colors,
					legend: {
						data: ['计划', '实际'],
						textStyle: {
							color: '#fff',
							padding: [3, 0, 0, 0],

						},
						top: '5%',
						right: '10%'
					},
					tooltip: {
						formatter: function(params) {
							return params.name + ':' + params.value[1] + '~' + params.value[2]
						}
					},
					grid: {
						left: '3%',
						right: '8%',
						top: '15%',
						bottom: '5%',
						containLabel: true
					},
					dataZoom: [
				        { // 第一个 dataZoom 组件
							type: 'slider' ,
							yAxisIndex:[0],
				          "start": 10,
          					"end": 80,
          					right:'2%'
				        },
				    ],
					xAxis: {
						type: 'time',
						axisLabel: {
							color: '#fff'
						},
						axisLine: {
							show: true,
							lineStyle: {

								lineStyle: {
									color: '#ffffff',
								}
							}
						},
						splitLine: {
							show: true,
							lineStyle: {

								color: "rgba(255,255,255,0.2)"
							}
						},
					},
					yAxis: {
						data: ['手续办理', '主要设备采购及到货', '施工进度计划', '调试及运行', '验收'],
						axisLine: {
							show: true,
							lineStyle: {

								lineStyle: {
									color: '#ffffff',
								}
							}
						},
						splitLine: {
							show: true,
							lineStyle: {

								color: "rgba(255,255,255,0.2)"
							}
						},
						axisLabel: {
							color: '#ffffff'
						},
					},
					series: [{
							name: '计划',
							type: 'custom',
							renderItem: function(params, api) {
								var categoryIndex = api.value(0)
								var start = api.coord([api.value(1), categoryIndex])
								var end = api.coord([api.value(2), categoryIndex])
								var height = 24

								return {
									type: 'rect',
									shape: echarts.graphic.clipRectByRect({
										x: start[0],
										y: start[1] - height,
										width: end[0] - start[0],
										height: height
									}, {
										x: params.coordSys.x,
										y: params.coordSys.y,
										width: params.coordSys.width,
										height: params.coordSys.height
									}),
									style: api.style()
								}
							},
							encode: {
								x: [1, 2],
								y: 0
							},
							itemStyle: {
								normal: {

									color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
										offset: 0,
										color: 'rgba(102,166,255,1)'
									}, {
										offset: 1,
										color: 'rgba(137,247,254,0)'
									}]),
									barBorderRadius: [30, 30, 0, 0],
								}
							},
							data: [{
									value: [0, '2018-08-25', '2018-12-13'] // 0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
								},
								{

									value: [1, '2018-06-15', '2018-11-14']
								},
								{

									value: [2, '2018-06-25', '2018-07-01']
								}
							]
						},
						{
							name: '实际',
							type: 'custom',
							renderItem: function(params, api) {
								var categoryIndex = api.value(0)
								var start = api.coord([api.value(1), categoryIndex])
								var end = api.coord([api.value(2), categoryIndex])
								var height = 24;
								return {
									type: 'rect',
									shape: echarts.graphic.clipRectByRect({
										x: start[0],
										y: start[1] ,
										width: end[0] - start[0],
										height: height
									}, {
										x: params.coordSys.x,
										y: params.coordSys.y,
										width: params.coordSys.width,
										height: params.coordSys.height
									}),
									style: api.style()
								}
							},
							encode: {
								x: [1, 2],
								y: 0
							},
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
										offset: 0,
										color: 'rgba(107,116,233,1)'
									}, {
										offset: 1,
										color: 'rgba(48,58,152,0)'
									}]),
								}
							},
							data: [{
									value: [2, '2018-08-25', '2018-12-13'] // 0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
								},
								{
									value: [1, '2018-06-15', '']
								},
								{
									value: [0, '2018-06-25', '']
								}
							]
						}
					]
				}
				myChart.setOption(option)
				this.postAxios('/build/progressPlanDaPingShow/selectMapForDaPingShowProgress', {1:1},'json').then(res => {
					
					let mapData = res.data.data

					option.yAxis.data = mapData.echartsDate['Y轴']
					let sjdata=[]
					let jhdata=[]
					for(let i=0;i<mapData.echartsDate['实际'].length;i++){
						sjdata.push({
							value:[i,mapData.echartsDate['实际'][i]['实际开始'],mapData.echartsDate['实际'][i]['实际结束']]
						})
						jhdata.push({
							value:[i,mapData.echartsDate['计划'][i]['计划开始'],mapData.echartsDate['计划'][i]['计划结束']]
						})
					}
					option.series[0].data = jhdata
					option.series[1].data = sjdata	
					myChart.setOption(option, true)
				}).catch(err => {})
			},
			zjindu() {
				const colors = ['#89F7FE', '#6B74E9']
				let myChart = echarts.init(document.getElementById('zSchedule'));
				let option = {
					color: colors,
					legend: {
						data: ['计划', '实际'],
						textStyle: {
							color: '#fff',
							padding: [3, 0, 0, 0],

						},
						top: '5%',
						right: '10%'
					},
					tooltip: {
						formatter: function(params) {
							return params.name + ':' + params.value[1] + '~' + params.value[2]
						}
					},
					grid: {
						left: '3%',
						right: '8%',
						top: '15%',
						bottom: '5%',
						containLabel: true
					},
					dataZoom: [
				        { // 第一个 dataZoom 组件
							type: 'slider' ,
							yAxisIndex:[0],
				          "start": 10,
          					"end": 80,
          					right:'2%'
				        },
				    ],
					xAxis: {
						type: 'time',
						axisLabel: {
							color: '#fff'
						},
						axisLine: {
							show: true,
							lineStyle: {

								lineStyle: {
									color: '#ffffff',
								}
							}
						},
						splitLine: {
							show: true,
							lineStyle: {

								color: "rgba(255,255,255,0.2)"
							}
						},
					},
					yAxis: {
						data: ['手续办理', '主要设备采购及到货', '施工进度计划', '调试及运行', '验收'],
						axisLine: {
							show: true,
							lineStyle: {

								lineStyle: {
									color: '#ffffff',
								}
							}
						},
						splitLine: {
							show: true,
							lineStyle: {

								color: "rgba(255,255,255,0.2)"
							}
						},
						axisLabel: {
							color: '#ffffff'
						},
					},
					series: [{
							name: '计划',
							type: 'custom',
							renderItem: function(params, api) {
								var categoryIndex = api.value(0)
								var start = api.coord([api.value(1), categoryIndex])
								var end = api.coord([api.value(2), categoryIndex])
								var height = 24

								return {
									type: 'rect',
									shape: echarts.graphic.clipRectByRect({
										x: start[0],
										y: start[1] - height,
										width: end[0] - start[0],
										height: height
									}, {
										x: params.coordSys.x,
										y: params.coordSys.y,
										width: params.coordSys.width,
										height: params.coordSys.height
									}),
									style: api.style()
								}
							},
							encode: {
								x: [1, 2],
								y: 0
							},
							itemStyle: {
								normal: {

									color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
										offset: 0,
										color: 'rgba(102,166,255,1)'
									}, {
										offset: 1,
										color: 'rgba(137,247,254,0)'
									}]),
									barBorderRadius: [30, 30, 0, 0],
								}
							},
							data: [{
									value: [0, '2018-08-25', '2018-12-13'] // 0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
								},
								{

									value: [1, '2018-06-15', '2018-11-14']
								},
								{

									value: [2, '2018-06-25', '2018-07-01']
								}
							]
						},
						{
							name: '实际',
							type: 'custom',
							renderItem: function(params, api) {
								var categoryIndex = api.value(0)
								var start = api.coord([api.value(1), categoryIndex])
								var end = api.coord([api.value(2), categoryIndex])
								var height = 24;
								return {
									type: 'rect',
									shape: echarts.graphic.clipRectByRect({
										x: start[0],
										y: start[1],
										width: end[0] - start[0],
										height: height
									}, {
										x: params.coordSys.x,
										y: params.coordSys.y,
										width: params.coordSys.width,
										height: params.coordSys.height
									}),
									style: api.style()
								}
							},
							encode: {
								x: [1, 2],
								y: 0
							},
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
										offset: 0,
										color: 'rgba(107,116,233,1)'
									}, {
										offset: 1,
										color: 'rgba(48,58,152,0)'
									}]),
								}
							},
							data: [{
									value: [2, '2018-01-25', '2018-12-13'] // 0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
								},
								{
									value: [1, '2018-06-15', '2018-12-14']
								},
								{
									value: [0, '2018-06-25', '2018-12-01']
								}
							]
						}
					]
				}

				this.postAxios('/build/progressPlanDaPingShow/selectMapForDaPingShowProgressMonth', {1:1},'json').then(res => {
					
					let mapData = res.data.data

					option.yAxis.data = mapData.echartsDate['Y轴']
					let sjdata=[]
					let jhdata=[]
					for(let i=0;i<mapData.echartsDate['实际'].length;i++){
						sjdata.push({
							value:[i,mapData.echartsDate['实际'][i]['实际开始'],mapData.echartsDate['实际'][i]['实际结束']]
						})
						jhdata.push({
							value:[i,mapData.echartsDate['计划'][i]['计划开始'],mapData.echartsDate['计划'][i]['计划结束']]
						})
					}
					option.series[0].data = jhdata
					option.series[1].data = sjdata	
					myChart.setOption(option, true)
				}).catch(err => {})

				myChart.setOption(option)
			}
		}
	}
</script>

<style scoped>
	.jd {
		height: 720px;
		position: relative;
	}
	
	#monthlySchedule {
		height: 720px;
		width: 948px;
	}
	
	#zSchedule {
		height: 720px;
		width: 948px;
	}
	
	.jdbgbox {
		position: absolute;
		z-index: 99;
		width: 335px;
		display: flex;
		justify-content: space-between;
		left: 72px;
		top: 29px;
	}
	
	.zjd {
		background: url(../../../assets/jindu/jdbg_1.png) no-repeat;
		background-size: 100% 100%;
		width: 159px;
		height: 37px;
		line-height: 37px;
		color: #FFFFFF;
		font-size: 16px;
		text-align: center;
	}
	
	.yjd {
		background: url(../../../assets/jindu/jdbg_2.png) no-repeat;
		background-size: 100% 100%;
		width: 159px;
		height: 37px;
		line-height: 37px;
		color: #FFFFFF;
		font-size: 16px;
		text-align: center;
	}
</style>